<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'LABEL.DRUG_COMPANY' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'LABEL.DRUG_COMPANY' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="drugcompanyForm">
        <div class="row m-t-20">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DRUG_COMPANY' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.DRUG_COMPANY' | translate }}" formControlName="name">
                    <mat-error *ngIf="drugcompanyForm.get('name')?.hasError('required') && 
                    (drugcompanyForm.get('name')?.dirty || drugcompanyForm.get('name')?.touched)">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="drugcompanyForm.get('name')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM50' | translate }}
                    </mat-error>
                </mat-form-field>

            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdateDrugCompany()" *ngIf="isEdit"
                [disabled]="drugcompanyForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onSaveDrugCompany()" *ngIf="!isEdit"
                [disabled]="drugcompanyForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>